export default "/assets/images/mila-feed-01-thumbnail.jpg?f8acf0e2cec5b2ffbc9ab2f8e3f1f82c";